const data = {
  'Home.message': "It's a beautiful day outside.",
  'home.beauty_advisor': '뷰티 프로페셔널',
  'home.virtual_mirror': '가상체험',
  'home.logout': '로그아웃',
  'home.lens_find': '',
  'home.look_for_you': '당신의 스타일을 찾아드립니다',
  'home.try_a_lens': '试试镜头',
  'home.color': '颜色',
  'home.lens_continue': '',
  'home.quiz_find': '',
  'without_quiz.lens_color': 'Try a lens color',
  'without_quiz.access_cam': '"디파인"이 사용자의 카메라에 접근하려고 합니다.',
  'without_quiz.access_cam_sub_text': '디지털 피팅 시도해보기',
  'without_image.img_confirm': '해당 이미지를 사용하시겠습니까?',
  'without_image.Allow': '허용 안 함',
  'without_image.OK': '승인함',
  'dba.find_look': '당신의 스타일을 찾아드립니다',
  'dba.trydba': 'Try the DBA App',
  'dba.about_urself': '당신의 스타일을 골라주세요',
  'dba.next': '다음',
  'dba.Currently wearing:': 'Currently wearing:',
  'quiz.skin_color': '당신의 피부톤은 무엇인가요?',
  'quiz.hair_Color': '당신의 헤어 컬러는 무엇인가요?',
  'menu.home': '홈으로',
  'menu.bye': '구매하기',
  'menu.share': '공유하기',
  'menu.save': '저장하기',
  'menu.trail': '무료 착용',
  'menu.find': '의사 찾기',
  'menu.product': '제품 정보',
  'lens.bright': '레디언트 브라이트™',
  'lens.shine': '네츄럴 샤인™',
  'lens.charm': '레디언트 챰™',
  'lens.chic': '레디언트 시크™',
  'lens.sweet': '레디언트 스위트™',
  'lens.vivid': '비비드 스타일',
  'lens.accent': '엑센트 스타일',
  'footer.care': '콘택트렌즈 착용&관리',
  'footer.products': '아큐브® 소개',
  'footer.legal': '법적고지',
  'footer.acuvue': '원데이 아큐브 디파인<sup>®</sup> 소개',
  'footer.contact': '고객센터',
  'footer.privacy': '개인정보처리방침',
  'footer.label': '사이트 소개',
  'footer.makeup': '메이크업 강좌',
  'login.email': 'E-mail',
  'login.password': 'Password',
  'login.submit': 'Submit',
  'nav.welcome_guest': '欢迎来客',
  'vm.currently_wearing': '目前穿着',
  'vm.rec_variant': '推荐的变种',
  'product_info.about': '원데이 아큐브 디파인® 소개',
  'lens.now': '지금',
  'tabs.lenses': '렌즈',
  'tabs.looks': '보다',
  'tabs.makeup': '메이크업',
  'tabs.insertion': '콘택트렌즈 착용',
  'tabs.removal': '콘택트 렌즈 제거',
  'tooltip.home': '홈으로',
  'tooltip.ba': '뷰티 어드바이져',
  'tooltip.care': '콘택트렌즈관리',
  'tooltip.more': '더 많은 옵션',
  'tooltip.buy': '구매하기',
  'tooltip.share': '공유하기',
  'tooltip.trial': '무료 착용',
  'tooltip.ecp': 'ECP 찾기',
  'tooltip.logout': '로그아웃',
  'tooltip.vm': '가상 체험',
  'modal.share': '공유하기',
  'modal.buy': '구매하기',
  'modal.free_trial': '무료 착용',
  'modal.shop_now': '구매하기',
  'modal.go': '가다/시작/진행',
  'looks.downloadPdf': '사용설명서 다운로드',
  'guides.how_to_put_on_lens': '콘택트렌즈를 쉽게 착용하는 방법 4단계',
  'guides.how_to_remove_lens': '콘택트렌즈를 쉽게 제거하는 방법 4단계',
  'looks.you_have_selected': '선택하셨습니다. ',
  'looks.you_have_chosen': '당신의 선택: ',
  'tutorials.or': 'OR',
  'tutorials.scan': 'QR를 이용하여 다운받기',
  'tutorials.product_unavailable':
    'This product is currently unavailable in this market.',
  'tutorials.look': 'Look ',
  'products.disclaimer_header': '법적고지/이용약관에 대하여',
  'tutorials.purchase': 'Buy online',
  'tutorials.lens': 'Lens',
  'looks.best_suited': 'look is best suited with',
  'looks.product_unavailable': 'Not Available',
  'looks.with_lens': 'With Lens:',
  'looks.with_looks': 'With Looks:',
  'permissions.allow_look_removal':
    '적용하신 메이크업 스타일을 삭제하시겠습니까?',
  'permissions.allow_makeup_removal': '적용하신 메이크업을 삭제하시겠습니까?',
  'permissions.allow_look_removal_sub_text': '계속 진행하시겠습니까?',
  'tabs.fresh_lenses': '디파인 프레쉬',
  'tabs.classic_lenses': '디파인 클래식',
  'tabs.makeup': '메이크업',
  'tabs.pls_select_look': '메이크업 스타일을 선택하세요',
  'tabs.pls_select_lens': '컬러렌즈를 선택하세요',
  'tabs.pls_select_makeup_category': '메이크업 종류를 선택하세요',
  'button.value_try_the': 'Try the',
  'button.heading_try_the': 'Lens',
  'button.value_find_your': '',
  'button.heading_find_your': '',
  'button.value_price': '',
  'button.heading_price': '',
  'button.sub-heading--lens-id' : '렌즈 가상 체험',
  'button.sub_heading_try_the' : '렌즈 가상 체험',
  'product.browser-alert' : '라이브 카메라 모드는 Internet Explorer 환경에서 지원되지 않습니다.',
  'appsflyer.appsflyer_message': '앱 설치하고 더 많은 혜택과 함께<br/>마이뷰티미러<sup>®</sup> 체험하기',
  'appsflyer.appsflyer_download': '다운로드'
};
export default data;
